import "material-icons/iconfont/material-icons.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./index.scss";
import i18n from "./i18n";
import axios from "axios";
import VueAxios from "vue-axios";
import titleMixin from "./mixins/titleMixin";
import formatDateMixin from "./mixins/formatDateMixin";
import formatMoneyMixin from "./mixins/formatMoneyMixin";
import ViewDefault from "@/views/PlaceOrderRedirectComponent.vue";
import HotelPlaceOrder from "@/views/HotelViews/HotelPlaceOrder.vue";
import CompanyPlaceOrder from "@/views/CompanyViews/CompanyPlaceOrder.vue";
import PassengerAutoComplete from "@/components/inputs/PassengerAutoComplete.vue";
import Datepicker from "vue3-date-time-picker";
import "@/style/datetime-picker.css";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import Notifications from "@kyvg/vue3-notification";
import Dialova from "@/plugins/dialova";
import PrimeVue from "primevue/config";
import Dialog from "primevue/dialog";
import "primevue/resources/themes/saga-blue/theme.css"; //theme
import "primevue/resources/primevue.min.css"; //core css
import "primeicons/primeicons.css";
import moment from "moment-timezone";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
library.add(fas, far, fab);


axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response &&  error.response.status=== 401 ) {
      store.commit("destroyToken");
      router.push("/login");
    }
    return Promise.reject(error);
  }
);

createApp(App)
  .component("redirect-view", ViewDefault)
  .component("hotel-view", HotelPlaceOrder)
  .component("company-view", CompanyPlaceOrder)
  .component("Dialog", Dialog)
  .component("Datepicker", Datepicker)
  .use(i18n)
  .use(store)
  .use(router)
  .mixin(titleMixin)
  .mixin(formatDateMixin)
  .mixin(formatMoneyMixin)
  .use(VueAxios, axios)
  .use(Notifications)
  .use(PrimeVue)
  .use(VueGoogleMaps, {
    load: {
      key: "AIzaSyAvWQlGwdRe7kdMxM9uHuEjjSkYxD1YmWs",
      libraries: "places",
    },
  })
  .use(Dialova, {
    components: {
      "passengers-autocomplete": PassengerAutoComplete,
    },
  })
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
